import React from 'react';
import { CustomerLocationAddress } from '../../common/types/models.ts';

const CustomerLocation = ({
  customerLocationAddress,
}: {
  customerLocationAddress: CustomerLocationAddress | null;
}) => {
  return (
    <div className="card">
      <div className="card-content">
        <div className="row">
          <h6>Send From</h6>
          <div className="divider" />
        </div>
        <div className="row" style={{ padding: '10px' }}>
          {customerLocationAddress && (
            <>
              <p>{customerLocationAddress.addressLineOne}</p>
              <p>{customerLocationAddress.addressLineTwo}</p>
              {customerLocationAddress.addressLineThree && (
                <p>{customerLocationAddress.addressLineThree}</p>
              )}
              <p>
                {customerLocationAddress.city},{' '}
                {customerLocationAddress.state?.code}
              </p>
              <p>{customerLocationAddress?.zip}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerLocation;
